import type { RouteLocationNormalized } from 'vue-router'

import { routeNames } from '@/router/routeNames'

export const EMBED_MESSAGE_SOURCE = 'flexbuilder'

export interface PathwaySubmittedMessage {
  type: 'pathway-submitted'
  flowUuid: string
  pathwayUuid: string
  url: string | null
}

type EmbedRoute = Pick<RouteLocationNormalized, 'name' | 'params'>

/** Konfigurator osadzony w iframe - dostęp do `window.top` z innej domeny rzuca wyjątek, więc to też jest osadzenie */
export function isEmbedded(): boolean {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
}

/** W osadzeniu wolno tylko zostać w ścieżce tego samego flow - strona główna, logowanie i panel są zablokowane */
export function isEmbeddedNavigationAllowed(
  to: EmbedRoute,
  from: EmbedRoute
): boolean {
  if (to.name !== routeNames.Pathway) return false
  if (from.name !== routeNames.Pathway) return true

  return to.params.flowUuid === from.params.flowUuid
}

/** Strażnik routera: w osadzeniu anuluje każde przejście poza ścieżkę tego samego flow */
export function embeddedNavigationGuard(
  to: EmbedRoute,
  from: EmbedRoute
): false | undefined {
  return isEmbedded() && !isEmbeddedNavigationAllowed(to, from)
    ? false
    : undefined
}

/** Wiadomość dla strony, która osadziła konfigurator - nie zawiera danych wrażliwych, więc trafia do dowolnego rodzica */
export function postToHost(message: PathwaySubmittedMessage): void {
  window.parent.postMessage({ source: EMBED_MESSAGE_SOURCE, ...message }, '*')
}
